import { render, staticRenderFns } from "./TabComponentOne.vue?vue&type=template&id=4a8ef002&scoped=true"
import script from "./TabComponentOne.vue?vue&type=script&lang=js"
export * from "./TabComponentOne.vue?vue&type=script&lang=js"
import style0 from "./TabComponentOne.vue?vue&type=style&index=0&id=4a8ef002&prod&scoped=true&lang=scss"
import style1 from "./TabComponentOne.vue?vue&type=style&index=1&id=4a8ef002&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ef002",
  null
  
)

export default component.exports